import request from '../../../api';

/**
 * Mark a batch of notifications as read.
 *
 * The same POST `components/Lists/NotificationsList.jsx` makes. It is a service
 * here rather than a call to that component's private helper because the
 * header's dropdown and the dashboard's panel both need it and neither renders
 * that list.
 *
 * Returns the promise and lets it throw, per the layer rule: no dispatch, no
 * translation, no toast. The hook decides what a failure means — and for this
 * one it means nothing the reader needs to be told about.
 *
 * NOTE — there is no companion for "clear". The API exposes `read` and nothing
 * that deletes, so the design's "مسح الكل" is implemented as "mark every one
 * read". See `docs/student-backend-gaps.md`.
 */
export const markNotificationsRead = (notificationsIds) =>
    request.post('/user/notifications/read', { notificationsIds });
